import Ionicons from "@react-native-vector-icons/ionicons";
import FontAwesome6 from "@react-native-vector-icons/fontawesome6";
import FontAwesome5 from "@react-native-vector-icons/fontawesome5";
import Feather from "@react-native-vector-icons/feather"
import MaterialCommunityIcons from "@react-native-vector-icons/material-design-icons";
import Svg, { Circle, Path } from 'react-native-svg';
import { withUnistyles, useUnistyles } from 'react-native-unistyles';

const libraryLookup = {
    'ionicon': withUnistyles(Ionicons),
    'fa': withUnistyles(FontAwesome6),
    'fa5': withUnistyles(FontAwesome5),
    'feather': withUnistyles(Feather),
    'material': withUnistyles(MaterialCommunityIcons)
};


const Unicon = ({testID, name, size, color, colorVariant, library = 'ionicon', style, iconStyle, solid = true}) => {
    // library= 'ionicon' | 'fa' | 'fa5' | 'feather' | 'material'
    // iconStyle= 'solid' | 'regular' | 'brand' (FontAwesome5/6 only); `solid` boolean is a shorthand for iconStyle='solid'

    const { theme } = useUnistyles();

    // `solid` boolean shorthand → iconStyle='solid' (used by existing fa5 call sites)
    const resolvedIconStyle = iconStyle || (solid ? 'solid' : undefined);

    // Extract color from style so it's passed as the `color` prop to the icon
    // component. On web, withUnistyles converts style to a CSS class, but the
    // icon's internal styleDefaults (color prop) is an inline style which has
    // higher specificity — so style-based color would be shadowed. Passing
    // color as a prop ensures it wins.
    let resolvedColor = color;
    let resolvedStyle = style;
    if (!resolvedColor && style) {
        const styleArr = Array.isArray(style) ? style : [style];
        for (const s of styleArr) {
            if (s && typeof s === 'object' && s.color) {
                resolvedColor = s.color;
                break;
            }
        }
        if (resolvedColor) {
            resolvedStyle = styleArr.map(s => {
                if (s && typeof s === 'object' && s.color) {
                    const rest = { ...s };
                    delete rest.color;
                    return rest;
                }
                return s;
            });
            resolvedStyle = Array.isArray(style) ? resolvedStyle : resolvedStyle[0];
        }
    }

    if (!resolvedColor && colorVariant) {
        resolvedColor = theme.colors[colorVariant];
    }

    if (name === 'user-round-arrow-left') {
        return (
            <Svg testID={testID} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={resolvedColor || theme.colors.text} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" style={resolvedStyle}>
                <Circle cx="10" cy="8" r="5" />
                <Path d="M2 21a8 8 0 0 1 13.292-6M22 19h-6m3-3-3 3 3 3" />
            </Svg>
        );
    }

    const IconComponent = libraryLookup[library];

    const iconProps = { testID, name, size, style: resolvedStyle };
    if (resolvedColor) {
        iconProps.color = resolvedColor;
    }
    // FontAwesome5/6 need iconStyle to select solid/regular/brand glyph set;
    // without it they default to 'regular' and solid-only icons render as ?
    if (resolvedIconStyle) {
        iconProps.iconStyle = resolvedIconStyle;
    }

    return <IconComponent {...iconProps} />;
}

export default Unicon
